import React from 'react';
import styles from './Button.module.scss';
import classNames from 'classnames';

export const Cypress_DATA = {
  button: 'base-button',
};

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  name?: string;
  value?: string;
  type?: 'button' | 'submit';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dataCy?: string;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  hoverBackgroundColor?: string;
  activeBackgroundColor?: string;
};

const Button = ({
  children,
  type,
  disabled,
  onClick,
  name,
  value,
  dataCy,
  backgroundColor,
  textColor,
  borderColor,
  hoverBackgroundColor,
  activeBackgroundColor,
}: Props) => {
  const buttonStyle = {
    '--button-bg': backgroundColor,
    '--button-text': textColor,
    '--button-border': borderColor,
    '--button-hover-bg': hoverBackgroundColor,
    '--button-active-bg': activeBackgroundColor,
  } as React.CSSProperties;

  return (
    <button
      type={type || 'button'}
      className={classNames(styles.wrapper)}
      style={buttonStyle}
      disabled={disabled}
      name={name}
      value={value}
      onClick={onClick}
      data-cy={dataCy || Cypress_DATA.button}
    >
      {children}
    </button>
  );
};

export default Button;
